<template>
  <div>
    <div v-if="!!schema.contentOfDocument" class="mt-2">
      <w-wysiwyg :model="schema.contentOfDocument" :config="contentConfig" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Dokumenty duplikatów
// @group ActionData
export default {
  components: { ...components },
  props: {
    // schema
    schema: { type: Object, required: true }
  },
  data() {
    return {
      // Konfiguracja zawartości
      contentConfig: { allowedContent: true, height: 150 }
    };
  }
};
</script>
